import config from "../config/app";
import * as API from "../utils/ApiHelper";

const { isProd } = config;

const API_ENDPOINT = isProd
  ? config.production.api_endpoint
  : config.development.api_endpoint;

// Get Home Details
export const appGetHome = () => {
  const url = `${API_ENDPOINT}/appGetHome`;
  return API.post(url, {});
};
